import React from 'react';
import { View } from 'react-native';
import AnimatedBottomSheet from '@components/common/ScreenAnimations/components/BottomSheet';
import { fullHeight, scale, webHeader } from '@components/frame';
import { useManageNavigatorBottomSheetWrapper } from './hooks/useManageNavigatorBottomSheetWrapper';
import { NavigatorBottomSheetWrapperProps } from './types';

const NavigatorBottomSheetWrapper: React.FC<NavigatorBottomSheetWrapperProps> = ({ children, screenNameToRemove, bottomSheetId }) => {
	const { onPresentedChange } = useManageNavigatorBottomSheetWrapper({ screenNameToRemove, bottomSheetId });

	return (
		<AnimatedBottomSheet
			onPresentedChange={onPresentedChange}
			containerStyle={{ height: fullHeight - webHeader, marginTop: webHeader }}
			scale={scale}
			skipAnimation={false}
			handleScroll={false}
			bottomSheetId={bottomSheetId}
		>
			<View style={{ height: '100%' }}>{children}</View>
		</AnimatedBottomSheet>
	);
};

export default NavigatorBottomSheetWrapper;
